module.exports = __webpack_public_path__ + "static/media/fullscreen.e67f954b.svg";